var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.61934 7.40686V3.4643C10.2669 3.63243 11.5613 4.45305 11.5613 5.40686V5.40623C11.5606 5.57123 11.6256 5.72935 11.7419 5.84623C11.8581 5.96248 12.0163 6.02811 12.1806 6.02811C12.3456 6.02811 12.5031 5.96248 12.6194 5.84623C12.7356 5.72936 12.8006 5.57123 12.8 5.40623C12.8 3.74559 11.0082 2.41743 8.61938 2.21999V1.41937C8.61813 1.07812 8.34125 0.80249 8 0.80249C7.65875 0.80249 7.38187 1.07812 7.38062 1.41937V2.21999C4.99182 2.4175 3.19998 3.74563 3.19998 5.40623C3.19998 7.06751 4.99182 8.39567 7.38062 8.59311L7.38062 12.5357C5.7331 12.3675 4.4387 11.5469 4.4387 10.5931V10.5937C4.43745 10.2525 4.16058 9.97686 3.81933 9.97686C3.47808 9.97686 3.2012 10.2525 3.19995 10.5937C3.19995 12.2544 4.99179 13.5825 7.38059 13.78V14.5806C7.38184 14.9219 7.65872 15.1975 7.99997 15.1975C8.34122 15.1975 8.6181 14.9219 8.61934 14.5806V13.78C11.0081 13.5825 12.8 12.2543 12.8 10.5937C12.8 8.93246 11.0081 7.6043 8.61934 7.40686ZM4.4387 5.40622C4.4387 4.4531 5.73307 3.63182 7.38062 3.46366V7.34862C5.7331 7.18049 4.4387 6.35987 4.4387 5.40606V5.40622ZM8.61934 12.5357V8.65134C10.2669 8.81947 11.5613 9.64009 11.5613 10.5939C11.5613 11.547 10.2669 12.3675 8.61934 12.5357Z",
    fill: "#1F2B22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.b72169bc2da547e19fd6568c2818e66d.svg";
export { ForwardRef as ReactComponent };